import { environment } from "@azm/environments/environment";

export function convertTokenJWT(token = localStorage.getItem(environment.tokenPropertyName) as string) {
	if (token) {
		if (!token.split(".")[1]) return;

		const payload = token.split(".")[1];
		if (!payload) return;

		let base64 = payload.replace(/-/g, "+").replace(/_/g, "/"),
			jsonPayload = decodeURIComponent(
				atob(base64)
					.split("")
					.map((c) => {
						return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
					})
					.join(""),
			);

		return JSON.parse(jsonPayload);
	}
}
